import React from 'react'

function HelpPage() {
  return (
    <div className="w-full h-full flex flex-col bg-white1 p-5 rounded-2xl shadow-2xl">HelpPage</div>
  )
}

export default HelpPage